export default __webpack_public_path__ + "static/media/login.e110da95.png";